import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { EmployeeFilter } from '@src/components/EmployeeFilter';
import { compact } from 'lodash';
import { SearchFilterBar, useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const ExceptionRequestsAdminTopNav = ({ tab, showFilter, filter, handleFilterChange, actions, }) => {
    const { t } = useLocale();
    const [searchText, setSearchText] = useState(filter?.searchText || '');
    useEffect(() => {
        if (handleFilterChange) {
            handleFilterChange({
                ...filter,
                searchText,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);
    const handleSearchChange = (searchValue) => {
        setSearchText(searchValue);
    };
    return (_jsx(AdminTopNav, { title: t('Exception Requests'), navLinks: compact([
            {
                title: t('Pending'),
                path: '/admin/exceptions/pending',
                selected: tab === 'pending',
            },
            {
                title: t('Info requested'),
                path: '/admin/exceptions/info_requested',
                selected: tab === 'info_requested',
            },
            {
                title: t('Processed'),
                path: '/admin/exceptions/processed',
                selected: tab === 'processed',
            },
        ]), searchFilterActions: showFilter &&
            filter &&
            handleFilterChange && (_jsx(SearchFilterBar, { enableSearch: true, enableFilter: true, filterActions: _jsx(EmployeeFilter, { filter: filter, onFilterChange: handleFilterChange }), isFilterActive: !!(filter?.clientId || filter?.startDate || filter?.endDate), onSearchChange: handleSearchChange, searchText: filter?.searchText || '', searchPlaceholder: t('Search by Name or Request #') })), actions: _jsx(_Fragment, { children: actions }) }));
};
